import React, { useState } from "react";

import {
  Typography,
  Box,
  Button,
  Divider,
  TextInput,
} from "digiwash-components";
import styled from "styled-components/native";
import { color } from "@sloth-system/styled-utils";
import { isNumeric } from "digiwash-core";
import userSelector from "../../ducks/user/selectors";
import { useSelector } from "react-redux";

interface PropTypes {
  handleLogin: (cellphone) => void;
  loading: boolean;
}
let UserInfoInput = styled(TextInput)`
  background-color: ${color("neutrals.200")};
  border: 0;
  border-radius: 16px;
`;
function PhoneStep(props: PropTypes) {
  let { cellphone } = useSelector(userSelector.login);
  let [phone, setPhone] = useState<number | string | undefined>(cellphone);
  let canFormBeSubmit = !!phone && !props.loading;

  return (
    <Box pt="xxl" pb="l" px="l">
      <Typography ff="mainBold" fs="l" color="common.black">
        ورود/نام‌نویسی
      </Typography>
      <Divider size="xxl" />
      <Box>
        <Box px="m">
          <Typography color="text.dark">
            لطفا شماره موبایل خود را وارد کنید تا کد فعال سازی برایتان فرستاده
            شود.
          </Typography>
        </Box>
        <Divider size="m" />

        <UserInfoInput
          value={phone}
          onChangeText={(text: number | string) => {
            if (text === "") {
              setPhone("");
            } else if (isNumeric(text)) {
              setPhone(text);
            }
            return false;
          }}
          placeholder="مثلا ۰۹۱۲۱۲۳۴۵۶۷"
          keyboardType="numeric"
          returnKeyType="done"
          onSubmitEditing={() => {
            if (canFormBeSubmit) {
              props.handleLogin(phone);
            }
          }}
        />
        <Divider size="l" />
        <Button
          onPress={() => {
            props.handleLogin(phone);
          }}
          outline
          disabled={!canFormBeSubmit}
        >
          مرحله بعد
        </Button>
      </Box>
    </Box>
  );
}

export default PhoneStep;
